module.exports = __webpack_public_path__ + "img/word.835d5091.png";